import { createReducer } from '@reduxjs/toolkit';

import { loadPayoutLimitsListSuccess, loadPayoutLimitsStart } from './actions';
import { IPayoutLimitsReducer } from './types';

const initialState: IPayoutLimitsReducer = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const PayoutLimitsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loadPayoutLimitsStart, (state) => ({ ...state, isLoading: true }))
    .addCase(loadPayoutLimitsListSuccess, (state, action) => ({ ...state, isLoading: false, isLoaded: true, data: action.payload }));
});

export default PayoutLimitsReducer;
